import _classCallCheck from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/apple/Documents/Personal/exibex/finnovexme/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import { ConnectLinks } from "./ConnectLinks";
export var Connect =
/*#__PURE__*/
function () {
  function Connect() {
    _classCallCheck(this, Connect);

    this.distance = 80;
    this.links = new ConnectLinks();
    this.radius = 60;
  }

  _createClass(Connect, [{
    key: "load",
    value: function load(data) {
      var _a, _b;

      if (data === undefined) {
        return;
      }

      if (data.distance !== undefined) {
        this.distance = data.distance;
      }

      this.links.load((_b = (_a = data.links) !== null && _a !== void 0 ? _a : data.lineLinked) !== null && _b !== void 0 ? _b : data.line_linked);

      if (data.radius !== undefined) {
        this.radius = data.radius;
      }
    }
  }, {
    key: "line_linked",
    get: function get() {
      return this.links;
    },
    set: function set(value) {
      this.links = value;
    }
  }, {
    key: "lineLinked",
    get: function get() {
      return this.links;
    },
    set: function set(value) {
      this.links = value;
    }
  }]);

  return Connect;
}();